/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from 'ng2-translate/src/translate.pipe';
import * as import3 from 'ng2-translate/src/translate.service';
import * as import4 from '../../string-utils/time.pipe';
import * as import5 from './store-status-panel.component';
import * as import6 from '../../ui-elements/touchable.directive';
import * as import7 from '../../ui-elements/toggle/toggle.component.ngfactory';
import * as import8 from '../../ui-elements/toggle/toggle.component';
import * as import9 from '../../ordering-context/ordering-context.model';
const styles_StoreStatusPanelComponent:any[] = ([] as any[]);
export const RenderType_StoreStatusPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_StoreStatusPanelComponent,
  data: {}
}
);
function View_StoreStatusPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'indicator'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['open']),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'indicator';
    const currVal_1:any = ck(v,2,0,co.isOpen);
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_StoreStatusPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(('woa.label.common.day.' + (<any>(<any>v.parent).parent).context.$implicit)));
    ck(v,1,0,currVal_0);
  });
}
function View_StoreStatusPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'details-hours-item-time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'details-hours-item-time-day'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'details-hours-item-time-hours'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'details-hours-item-time-hours-start'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n                    -\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'details-hours-item-time-hours-end'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.first;
    ck(v,5,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'open-day-',(<any>v.parent).context.$implicit,'');
    ck(v,2,0,currVal_0);
    const currVal_2:any = import0.ɵinlineInterpolate(1,'open-time-',(<any>v.parent).context.$implicit,'-start');
    ck(v,10,0,currVal_2);
    const currVal_3:any = import0.ɵunv(v,11,0,ck(v,12,0,import0.ɵnov((<any>(<any>v.parent).parent),0),v.context.$implicit.start,'hh:mm a'));
    ck(v,11,0,currVal_3);
    const currVal_4:any = import0.ɵinlineInterpolate(1,'open-time-',(<any>v.parent).context.$implicit,'-end');
    ck(v,14,0,currVal_4);
    const currVal_5:any = import0.ɵunv(v,15,0,ck(v,16,0,import0.ɵnov((<any>(<any>v.parent).parent),0),v.context.$implicit.end,'hh:mm a'));
    ck(v,15,0,currVal_5);
  });
}
function View_StoreStatusPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'details-hours-item-time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'details-hours-item-time-day'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'details-hours-item-time-hours'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'closed-day-',(<any>v.parent).context.$implicit,'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,5,0,import0.ɵnov(v,6).transform(('woa.label.common.day.' + (<any>v.parent).context.$implicit)));
    ck(v,5,0,currVal_1);
    const currVal_2:any = import0.ɵinlineInterpolate(1,'closed-time-',(<any>v.parent).context.$implicit,'');
    ck(v,9,0,currVal_2);
    const currVal_3:any = import0.ɵunv(v,10,0,import0.ɵnov(v,11).transform('woa.label.store-details.storeClosedForTheDay'));
    ck(v,10,0,currVal_3);
  });
}
function View_StoreStatusPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'details-hours-item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_3)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.store.storeOpeningHours[v.context.$implicit].hours;
    ck(v,5,0,currVal_0);
    const currVal_1:any = co.store.storeOpeningHours[v.context.$implicit].closedForTheDay;
    ck(v,10,0,currVal_1);
  },(null as any));
}
export function View_StoreStatusPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import4.WOATimePipe,([] as any[])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'details-title'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.StoreStatusPanelComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleHours(import0.ɵnov(v,17))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(4210688,(null as any),0,import6.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'details-title-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-toggle',[[
        'class',
        'details-title-toggle'
      ]
    ],(null as any),(null as any),(null as any),import7.View_ToggleComponent_0,import7.RenderType_ToggleComponent)),
      import0.ɵdid(573440,(null as any),0,import8.ToggleComponent,[import0.ChangeDetectorRef],{active: [
        0,
        'active'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,[[
        'hours',
        1
      ]
      ],(null as any),4,'div',[[
        'class',
        'details-hours'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreStatusPanelComponent_2)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n']))
  ]
  ,(ck,v) => {
    var co:import5.StoreStatusPanelComponent = v.component;
    const currVal_0:any = co.store;
    ck(v,2,0,currVal_0);
    const currVal_2:any = co.showHours;
    ck(v,14,0,currVal_2);
    const currVal_3:any = co.daysOfWeek;
    ck(v,20,0,currVal_3);
  },(ck,v) => {
    var co:import5.StoreStatusPanelComponent = v.component;
    const currVal_1:any = import0.ɵunv(v,10,0,import0.ɵnov(v,11).transform(co.statusLabel));
    ck(v,10,0,currVal_1);
  });
}
function View_StoreStatusPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-status-panel',([] as any[]),(null as any),(null as any),(null as any),View_StoreStatusPanelComponent_0,RenderType_StoreStatusPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import5.StoreStatusPanelComponent,[import9.OrderingContextModel],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const StoreStatusPanelComponentNgFactory:import0.ComponentFactory<import5.StoreStatusPanelComponent> = import0.ɵccf('woa-store-status-panel',import5.StoreStatusPanelComponent,View_StoreStatusPanelComponent_Host_0,{
  store: 'store',
  filteredOrderType: 'filteredOrderType'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/store/store-status-panel/store-status-panel.component.ngfactory.ts